import React from 'react';
import ErrorPage from '../../Reusable_Components/Error Components/ErrorPage';

const NotFound = () => <ErrorPage code={404} />;

export default NotFound;
